import Vue from "vue";
import { Message } from "element-ui";
import axios from "axios";
import qs from "qs";
import base from "./base.js"
import store from "@/store";
import router from '@/router'

const getEnv = function () {
  const localHref = window.location.href
  const isDev = /(:\/\/localhost|:\/\/127.0.0.1|:\/\/192.168.)/.test(localHref)
  if (isDev) {
    return 'dev-'
  }
  const pattern = /(dev-|test-|uat-|pre-)/i
  const matcher = localHref.match(pattern)
  if (matcher && matcher.length >= 2) {
    return matcher[1]
  }
  return ''
}


const baseURL = 'https://' + getEnv() + 'boss.eselltech.cn/api/'

axios.defaults.baseURL = baseURL
axios.interceptors.request.use(
  function (config) {
    // 在请求发出之前进行一些操作
    // config.headers = { "Content-Type": "multipart/form-data" };
    if (config.method === 'post') {
      config.data = qs.stringify(config.data)
    }
    return config
  },
  function (err) {
    return Promise.reject(err)
  }
)
// 添加一个响应拦截器
axios.interceptors.response.use(
  function (res) {
    /* if (res.headers && res.request.responseType == 'blob' && (res.headers['content-type'] === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
      let fileName = decodeURI(res.headers['content-disposition'].split('filename=')[1]);
      base.createDownloadFile(res.data, fileName);
    } */
    return res
  },
  function (err) {
    return Promise.reject(err)
  }
)

var DataToString = function (data) {
  if (Array.isArray(data)) {
    return JSON.stringify(data)
  }
  let strObj = {}
  for (let key in data) {
    Object.assign(strObj, {
      [key]: data[key]
    })
  }
  return JSON.stringify(strObj)
}

var toUrlString = function (url, data) {
  const { payload, token } = data
  let keyMap = {
    appid: 'Jvddh8LKdLwmZ3cw',
    appkey: 'JT08vIDioMkOGdrry5oqJkxqFmc47YYR',
    payload: payload,
    sequence: new Date().getTime(),
    timestamp: new Date().getTime(),
    token: token,
    uuid: getUuid(),
    version: '1.3' + new Date().getTime()
  }
  if (!token) {
    delete keyMap.token
  }
  let singString = queryString(keyMap)
  /* global md5 */
  let sign = md5(singString)
  delete keyMap.appkey
  delete keyMap.payload
  return url + '?' + queryString(keyMap) + '&sign=' + sign
}

var queryString = function (keyMap) {
  let result = ''
  for (let element in keyMap) {
    result += element + '=' + keyMap[element] + '&'
  }
  return result.substring(0, result.length - 1)
}

// 获取与生成uuid
var getUuid = function () {
  let uuid
  const guid = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0
      let v = c === 'x' ? r : (r & 0x3) | 0x8
      return v.toString(16)
    })
  }
  try {
    uuid = localStorage.getItem('uuid')
  } catch (error) {}

  if (uuid && uuid !== 'undefined') {
    return uuid
  } else {
    uuid = guid()
    try {
      localStorage.setItem('uuid', uuid)
    } catch (error) {}
    return uuid
  }
}

var getToken = function () {
  return store.state.token
}

const login = function (url, data) {
  let datas = {
    payload: DataToString(data)
  }
  return new Promise((resolve, reject) => {
    axios
      .post(toUrlString(url, { payload: datas.payload }), datas, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(res => {
        let { data } = res
        if (data.code === 0) {
          resolve(data)
        } else {
          reject(data)
        }
      })
      .catch(res => {
        let { data } = res.response
        reject(data)
      })
  })
}

const send = function (url, data = {}, responseType = '') {
  let datas = { payload: DataToString(data) }
  return new Promise((resolve, reject) => {
    axios.post(toUrlString(url, { payload: datas.payload, token: getToken() }), datas, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      responseType: responseType
    })
      .then(res => {
        let { data } = res
        if (data.code === 0) {
          resolve(data)
        } else if (data.code === -11004 || data.code === -10008) {
          Message({
            message: data.message,
            type: 'error',
            duration: 3000
          })
          store.dispatch('logout').then(() => {
            router.replace({ path: "/login" });
            console.log("退出登录")
          })
        } else if (responseType === 'blob') {
          resolve(data)
        } else {
          reject(data)
        }
      })
      .catch(res => {
        let { data } = res.response || ''
        reject(data)
      })
  })
}

//文件通过创建iframe下载
const download = function(url, data = "") {
  let keyMap = {
    appid: "Jvddh8LKdLwmZ3cw",
    appkey: "ngywG2T3eCXVYtsr",
    sequence: new Date().getTime(),
    timestamp: new Date().getTime(),
    token: getToken(),
    uuid: getUuid(),
    version: "1.3" + new Date().getTime()
  };
  if(data) {
    let datas = { payload: DataToString(data)};
    keyMap['payload'] = datas.payload;
  }
  let singString = queryString(keyMap);
  let sign = md5(singString);
  delete keyMap.appkey;
  let downUrl = axios.defaults.baseURL + url + "?" + queryString(keyMap) + "&sign=" + sign
  base.createDownloadFile(downUrl);
}


const http = {
  login,
  send,
  getEnv,
  download,
  baseURL
};
export default http;



// WEBPACK FOOTER //
// ./src/api/request.js